import { Component, HostBinding, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxComponentDef } from '@df/ui/form/checkbox/checkbox.component.def';
@Component({
    selector: 'checkbox',
    templateUrl: 'checkbox.html',
    styleUrls: ['checkbox.scss'],
    standalone: true,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ]
})
export class CheckboxComponent extends CheckboxComponentDef {
    @HostBinding('class.checkbox')
    getCheckbox = true;
    @HostBinding('class.is-checked')
    get getIsChecked() {
        return this.checked;
    }
    @HostBinding('class.is-disabled')
    get getIsDisabled() {
        return this.disabled;
    }
}
